<template>
  <div class="shop-root">
    <span class="float-right shop-points text-info">{{ points[shopType + '_points'] | number }}</span>
    <div v-if="shopType == 'event'" class="shop-title text-info">Eventos y Conciertos</div>
    <div v-if="shopType == 'card'" class="shop-title text-info">Certificados Digitales</div>
    <div v-if="shopType == 'gift'" class="shop-title text-info">Premios en Especie</div>
    <div v-if="shopType == 'wallet'" class="shop-title text-info">Dépositos en Monedero</div>
    <hr />
    <table class="w-100" v-if="pointProducts.length > 0">
      <tr v-for="(product, index) in pointProducts" :key="`product-${index}`">
          <td class="shop-product-col text-center">
            <div class="shop-product-box">
              <span v-if="product.city" class="float-right shop-city">{{ product.city }}</span>
              <br v-if="product.city" />
              <br v-if="product.city" />
              <img :src="product.image_filename ? product.image_filename : 'no-image.jpg'" class="shop-image">
              <br /><br />
              {{ product.description }}
              <br /><br />
              <template v-if="isWalletRange(product)">
                <b>Minimo {{ getRangeStart(product) | number }} puntos | Maximo {{ getRangeEnd(product) | number }}</b>
              </template>
              <template v-else>
                <b>{{ product.price | number }} Puntos</b>
              </template>
              <span v-if="canBuyProduct(product)">
                <br /><br />
                <CButton @click="$emit('select-product', product)" :color="'success'" size="sm" class="m-1 shop-buy-button">COMPRAR</CButton>
              </span>
              <span v-else>
                <span v-if="showNoDisponible(product)" class="text-info">
                  <br /><br /><b>NO DISPONIBLE</b>
                </span>
                <span v-else class="text-info">
                  <span v-if="product.is_bought" class="text-info">
                    <br /><br /><b>ESTE PREMIO YA HA SIDO CANJEADO</b>
                  </span>
                  <span v-else class="text-info">
                    <span v-if="!hasEnoughPoints(product)" class="text-info">
                      <br /><br />
                      <b v-if="isWalletRange(product)">NECESITAS AL MENOS {{ getRangeStart(product) | number }} PUNTOS</b>
                      <b v-else>NO TIENES PUNTOS SUFICIENTES</b>
                    </span>
                  </span>
                </span>
              </span>
            </div>
          </td>
      </tr>
    </table>
    <div v-else class="text-center w-100">NO HAY PREMIOS DISPONIBLES PARA ESTA CATEGORÍA</div>
    <hr />
  </div>
</template>

<script>
export default {
  name: 'RewardsShop',
  props: {
    points: {
      type: Object,
      default: () => ({})
    },
    shopType: {
      type: String,
      default: 'event'
    },
    pointProducts: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    currentPoints () {
      return Number(this.points[this.shopType + '_points'] || 0)
    }
  },
  methods: {
    isWalletRange (product) {
      return product.type === 'wallet_points' && product.wallet_mode === 'range'
    },
    getRangeStart (product) {
      return Math.max(0, Number(product.range_start || 0))
    },
    getRangeEnd (product) {
      return Math.max(0, Number(product.range_end || 0))
    },
    getRangeStep (product) {
      return Math.max(1, Number(product.range_step || 1))
    },
    hasEnoughPoints (product) {
      if (this.isWalletRange(product)) {
        return this.currentPoints >= this.getRangeStart(product)
      }

      return this.currentPoints >= Number(product.price || 0)
    },
    canBuyProduct (product) {
      const hasStock = this.isWalletRange(product) ? true : Number(product.stock || 0) > 0
      const canBuyMultiple = product.is_multiple == 1 || (product.is_multiple == 0 && product.is_bought == 0)

      return hasStock && this.hasEnoughPoints(product) && canBuyMultiple
    },
    showNoDisponible (product) {
      if (this.isWalletRange(product)) {
        return false
      }

      return Number(product.stock || 0) === 0
    }
  }
}
</script>

<style scoped>
.shop-root {
  font-size: 12px;
}

.shop-points {
  font-size: 18px;
  font-weight: bold;
}

.shop-title {
  font-size: 14px;
  font-weight: bold;
}

.shop-product-col {
  width: 33%;
  height: 120px;
  padding: 5px;
}

.shop-product-box {
  border: 1px solid;
  padding: 20px;
}

.shop-city {
  font-size: 12px;
  font-style: italic;
  font-weight: bold;
}

.shop-image {
  height: 120px;
}

.shop-buy-button {
  font-size: 12px;
}

</style>
